import React from 'react'

import Alert from 'admin/components/common/Alert'
import Loader from 'components/ui/Loader'
import { AlertLevels } from 'types'

/**
 * Loader/placeholder component for dynamic loading of routes and components, allowing Webpack to split code into chunks
 */
class AsyncComponent extends React.Component<
  AsyncComponentProps,
  AsyncComponentState
> {
  static defaultProps = {
    loader: false,
  }

  state = {
    component: null,
    isLoading: false,
    error: null,
  }

  constructor(props) {
    super(props)
  }

  loadComponent(path) {
    this.setState({
      component: null,
      isLoading: true,
      error: null,
    })
    import(`../${  path}`)
      .then(module => {
        this.setState({
          component: module.default,
          isLoading: false,
        })
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          error,
        })
      })
  }

  componentDidMount() {
    if (this.props.path) {
      this.loadComponent(this.props.path)
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.path !== this.props.path) {
      this.loadComponent(this.props.path)
    }
  }

  render() {
    const { component, isLoading, error } = this.state
    const { componentProps, loader } = this.props
    if (component) {
      return React.createElement(component, componentProps)
    } if (error) {
      return (
        <Alert
          alert={{
            level: AlertLevels.ERROR,
            message: 'UNKNOWN_ERROR',
            data: error,
          }}
        />
      )
    } if (isLoading) {
      if (loader) {
        if (loader === true) {
          return <Loader visible />
        } 
          return loader
        
      } 
        return null
      
    } 
      return null
    
  }
}

type AsyncComponentProps = {
  path: string
  componentProps?: {
    [key: string]: any
  }
  loader?: React.ReactNode | boolean
}

type AsyncComponentState = {
  component: React.ReactNode | null
  isLoading: boolean
  error: any
}

export default AsyncComponent
